
import {
    IdTicketsStateDataItem,
    typeTicketResponse,
    typeTicketsFilters
} from "model/dashboardTickets/dTicketsReducer";
import { apiClient } from 'model/axiosConfig';

// Type
export type typeTicketsRequestFilters = {
    filters: {
        dateCreated?: {
            from: string,
            to: string,
        } | {},
        description?: string | string[] | null,
        name?: string | string[] | null,
        status?: string | null,
    },

    sortFilter?: {
        direction: string,
        column: string
    }
}

// Get Tickets list
export const getTicketsList = async ( payload: {  filters: typeTicketsFilters } ) => {

    const path = 'support/ticket/search'
    const config = {
        headers: {},
    }
    const data: typeTicketsRequestFilters = {
        filters: {},
        sortFilter: {
            direction: "DESC",
            column: "dateCreated"
        }
    }

    if (payload.filters.name) data.filters.name! = [ payload.filters.name ]
    if (payload.filters.description) data.filters.description = [ payload.filters.description ]
    if ('status' in payload.filters) data.filters.status = payload.filters.status
    if (payload.filters.dateCreated) { data.filters.dateCreated! = payload.filters.dateCreated }


    try {
        return await apiClient.post(path, data, config)
    } catch (error) {
        return error
    }
}

// Add ticket item
export const addTicketsItem = async ( payload: {  dataObject: { name: string, description: string, status: string } } ) => {

    const path = '/support/ticket'
    const config = {
        headers: {},
    }
    const data = payload.dataObject

    try {
        const response = await apiClient.post(path, data, config)
        return response
    } catch (error) {
        return error
    }
}

// Change status Tickets item
export const changeTicketsItem = async ( payload: {  dataObject: IdTicketsStateDataItem } ) => {

    const path = '/support/ticket'
    const config = {
        headers: {},
    }
    const data = payload.dataObject

    try {
        const response = await apiClient.patch(path, data, config)
        return response
    } catch (error) {
        return error
    }
}

// Add response for ticket

export const addTicketResponse = async ( payload: { dataObject: typeTicketResponse } ) => {

    const path = `/support/ticket/${payload.dataObject.id}/response`
    const config = {
        headers: {},
    }
    const data = {
        text: payload.dataObject.text,
        viewedByUser: true
    }

    try {
        const response = await apiClient.post(path, data, config)
        return response
    } catch (error) {
        return error
    }
}

//Set response viewed for ticket -> viewed=true

export const viewedTicketResponse = async ( payload: { dataObject: typeTicketResponse } ) => {

    const path = '/support/ticket/response'
    const config = {
        headers: {},
    }


    try {
        const response = await apiClient.patch(path, payload.dataObject, config)
        return response
    } catch (error) {
        return error
    }
}


export const getMerchantData = async (merchantId: string) => {

    const path = `/admin/merchant/${encodeURI(merchantId)}`

    const config = {
        headers: {}
    }

    try {
        const response = await apiClient.get(path, config)
        return response

    } catch (error) {
        console.log(error)
        return error

    }
}
